import React from 'react';

const ProductsError: React.FC = () => {
  return (
    <>
      <h2 className="text title font-semibold text-xl md:pt-10 pt-6 text-center text-red-500">
        Error
      </h2>
      <p className="text text-red-500 text-center pt-5">
        Something goes wrong, please try later 😕
      </p>
    </>
  );
};

export default ProductsError;
